import { ReactNode } from 'react';

import styled from 'styled-components';

export interface UserFormSectionProps {
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
}

export const UserFormSection = (props: UserFormSectionProps) => {
  const { title, description, children } = props;

  return (
    <Wrapper>
      {title && (
        <Header>
          <Title>{title}</Title>
          {description && <Description>{description}</Description>}
        </Header>
      )}
      <Body
        style={{
          paddingTop: title ? undefined : '20px',
        }}
      >
        {children}
      </Body>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: white;
  border-bottom: 12px solid #eeeeee;
`;

const Header = styled.div`
  padding: 32px 16px 16px;
`;

const Title = styled.label`
  display: block;
  color: #2c384a;
  font-size: var(--font-size-18, 18px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const Description = styled.div`
  margin-top: 4px;
  color: #5e6774;
  text-align: left;
  font-size: var(--font-size-14, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.28px;
`;

const Body = styled.div`
  padding: 0 16px 24px;
`;
